import { useHookstate } from "@hookstate/core";
import { rootComponentsStore } from "../hookstate/rootComponentsStore";

export function useWasSameOrigin() {
  const locationHistory = useHookstate(rootComponentsStore.locationHistory);
  return locationHistory.get().length > 1;
}
